<form
            class="search-filter dark-theme"
            [ngClass]="{'search-filter-focused': searchFilterFocused}"
            #searchForm="ngForm"
            
        >
            <label for="search-filter-field" class="icon" >
                <svg *ngIf="!searchFilterFocused" xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="none" stroke="#15151c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535"/></svg>
                <svg *ngIf="searchFilterFocused" xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="none" stroke="#15151c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535"/></svg>
            </label>
            <input
                
                name="searchForm"
                type="text"
                class="txt"
                id="search-filter-field"
                placeholder="{{searchFilterFocused ? 'Search titles, networks' : 'Search'}}"
                (focus)="searchFilterFocused = true"
                [(ngModel)]="search"
                [disabled]="isBulkSaving"
            >
            <input
                type="reset"
                value="Cancel"
                class="btn-reset"
                (click)="searchFilterFocused = false;search = '';applyFilter()"
                [disabled]="isBulkSaving"
            >
            <input type="submit" value="Search" class="btn-submit" 
            (click)="filterData(search)" [disabled]="isBulkSaving">
            <!-- <mat-select class="search-category-select" [(ngModel)]="searchCategory" (ngModelChange)="unassignMapping(i)"> -->
            
            <mat-form-field appearance="fill">
                <mat-label>Search Category</mat-label>
                <mat-select class="search-category-select custom-backdrop-class" panelClass="filter-select filter-status"
                 [(ngModel)]="searchCategory" style="color: white" (selectionChange)="applyFilter()" [ngModelOptions]="{standalone: true}" [disabled]="isBulkSaving">
                    <!-- <mat-option disabled>Select a search category</mat-option> -->
                    <mat-option *ngFor="let cat of searchCategories;" [value]="cat">{{cat}}</mat-option>
                </mat-select>
            </mat-form-field>
        </form>

<div class="bulk-actions">
    <span>{{ selectedRows.size }} row(s) selected</span>
    <mat-form-field class="bulk-partner-group" appearance="fill">
        <mat-label>Partner Group</mat-label>
        <mat-select [(ngModel)]="selectedPartnerGroupId" (selectionChange)="pendingBatch = null"
            [disabled]="isBulkSaving || isFetchingTableData" panelClass="filter-select filter-status">
            <mat-option *ngFor="let group of partnerGroups" [value]="group.id">{{ group.name }}</mat-option>
        </mat-select>
    </mat-form-field>
    <button type="button" class="button" [disabled]="!canBulkCreate" (click)="prepareBulkCreate()">
        {{ isBulkSaving ? 'Creating shows...' : 'Create Selected Shows' }}
    </button>
    <button type="button" class="button" [disabled]="!selectedRows.size || isBulkSaving" (click)="clearSelection()">
        Clear Selection
    </button>
    <p class="bulk-help">Select all applies to filtered results across all pages. Changing filters deselects hidden rows.
        Titles are trimmed and combined without regard to case; one show is created per unique title.</p>
</div>

<ng-template #bulkDialog>
    <div class="bulk-dialog dialog-container green-theme">
        <div class="dialog-header">
            <h2 mat-dialog-title>{{ bulkDialogFinished ? 'Bulk Show Results' : 'Create Shows in Bulk' }}</h2>
        </div>
        <mat-dialog-content class="dialog-body">
            <div *ngIf="pendingBatch" class="bulk-confirmation">
                <p>Create {{ pendingBatch.request.shows.length }} unique show(s) from {{ pendingBatch.rowCount }} selected row(s)
                    for partner group <strong>{{ pendingBatch.groupName }}</strong>?</p>
                <ul>
                    <li *ngFor="let show of pendingBatch.request.shows">{{ show.title }}</li>
                </ul>
                <p>Shows will be created with empty notes. This action creates shows; it does not reassign existing shows
                    or create alternate-title mappings.</p>
            </div>
            <div *ngIf="isBulkSaving || isFetchingTableData" class="bulk-progress" role="status" aria-live="polite">
                <mat-progress-bar mode="indeterminate" aria-label="Bulk show creation progress"></mat-progress-bar>
                <p>{{ isBulkSaving ? 'Creating shows. Please wait...' : 'Refreshing show lists. Please wait...' }}</p>
                <p *ngIf="dialogBatch">Processing {{ dialogBatch.request.shows.length }} unique show(s) for {{ dialogBatch.groupName }}.</p>
            </div>
            <p *ngIf="bulkMessage" class="bulk-status" role="status">{{ bulkMessage }}</p>
            <p *ngIf="bulkError" class="bulk-error" role="alert">{{ bulkError }}</p>
            <ul *ngIf="bulkDialogResults.length" class="bulk-results" aria-label="Individual show results">
                <li *ngFor="let result of bulkDialogResults">
                    <strong>{{ result.title }}</strong>
                    <span [class.bulk-status]="result.succeeded" [class.bulk-error]="!result.succeeded">{{ result.message }}</span>
                </li>
            </ul>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button *ngIf="pendingBatch" type="button" class="form-button bulk-confirm" (click)="confirmBulkCreate()"
                [disabled]="!canBulkCreate">Confirm Create</button>
            <button type="button" class="form-button form-button-cancel bulk-close" (click)="closeBulkDialog()"
                [disabled]="isBulkSaving || isFetchingTableData">{{ bulkDialogFinished ? 'Close' : 'Cancel' }}</button>
        </mat-dialog-actions>
    </div>
</ng-template>

<div class="show-table-scroll">
<mat-table [dataSource]="tableData" matSort class="track-list" multiTemplateDataRows>
    <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
            <mat-checkbox class="select-all-shows" [checked]="allFilteredSelected"
                [indeterminate]="selectedRows.size > 0 && !allFilteredSelected"
                [disabled]="isBulkSaving || isFetchingTableData || !selectableRows.length || bulkResultUncertain"
                (change)="toggleAllFiltered()" aria-label="Select all filtered shows across all pages">
            </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
            <mat-checkbox class="select-show" [checked]="selectedRows.has(row)"
                [disabled]="isBulkSaving || isFetchingTableData || !canSelectRow(row) || bulkResultUncertain"
                (change)="toggleRow(row)" [aria-label]="'Select ' + row.showName + ' on ' + row.networkService">
            </mat-checkbox>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef>Title</mat-header-cell>
        <mat-cell *matCellDef="let row" class="show-title">
            <span>{{ row.showName }}</span>
            <span *ngIf="rowErrors.get(titleKey(row))" class="bulk-error">{{ rowErrors.get(titleKey(row)) }}</span>
            <span *ngIf="createdTitles.has(titleKey(row))" class="bulk-status">Created in this session</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="network">
        <mat-header-cell *matHeaderCellDef>
            <div class="network-filter">
                <span class="network-header-label">Network</span>
                <mat-select [(ngModel)]="selectedNetwork" (selectionChange)="applyFilter()"
                    panelClass="filter-select filter-status" [disabled]="isBulkSaving" aria-label="Filter by network">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="networkSearch"
                            [ngModelOptions]="{standalone: true}"
                            placeholderLabel="Search networks"
                            noEntriesFoundLabel="No networks found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option value="">All Networks</mat-option>
                    <mat-option *ngFor="let network of filteredNetworks" [value]="network">
                        {{ network }}
                    </mat-option>
                </mat-select>
            </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.networkService }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
            <button class="button" (click)="openCreateShowModal(row)" [disabled]="isBulkSaving || isFetchingTableData || createdTitles.has(titleKey(row)) || bulkResultUncertain">Create Show</button>
            <button class="button" (click)="openMapShowModal(row)" [disabled]="isBulkSaving || isFetchingTableData">Map Show</button>
        </mat-cell>
    </ng-container>

    <!-- <ng-container matColumnDef="genre">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Genre</mat-header-cell>
        <mat-cell *matCellDef="let row">
            {{ row.genre && row.genre.parent ? row.genre.parent.name : row.genre ? row.genre.name : "" }}
        </mat-cell>
    </ng-container> -->

    <!-- <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let row">
            <span *ngIf="row.status == 'PENDING'" class="status-bullet" style="background-color: #E3B950;"
                [matTooltip]="pendingBtn" matTooltipPosition="left" matTooltipClass="tooltip-white"></span>
            <span *ngIf="row.status == 'PENDING_APPROVAL'" class="status-bullet" style="background-color: #47CDEF;"
                [matTooltip]="pendingApproveBtn" matTooltipPosition="left" matTooltipClass="tooltip-white"></span>
            <span *ngIf="row.status == 'APPROVED'" class="status-bullet" style="background-color: #50E3C2;"
                [matTooltip]="approveBtn" matTooltipPosition="left" matTooltipClass="tooltip-white"></span>
            <span *ngIf="row.status == 'DENIED'" class="status-bullet" style="background-color: #D73939;"
                [matTooltip]="denieBtn" matTooltipPosition="left" matTooltipClass="tooltip-white"></span>
            <span *ngIf="row.status == 'DISABLED'" class="status-bullet" style="background-color: #8A8A8D;"
                [matTooltip]="disableBtn" matTooltipPosition="left" matTooltipClass="tooltip-white"></span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
            <button type="button" (click)="$event.preventDefault();$event.stopPropagation();rowClicked1(row)"
                class="versions-toggle" class="expand-button">
                <svg width="10px" height="5px" viewBox="0 0 10 5" class="carrot"
                    [ngClass]="{ flip: trackIsExpanded(row) }">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
                        stroke-linejoin="round">
                        <g transform="translate(-1392.000000, -396.000000)" class="inner-stroke" stroke-width="0.95">
                            <g transform="translate(392.000000, 351.000000)">
                                <g transform="translate(920.550000, 36.100000)">
                                    <polyline points="80.75 9.5 84.55 13.3 88.35 9.5"></polyline>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </button>
        </mat-cell>
    </ng-container> -->

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" class="main-row"></mat-row>
    <!-- <mat-row *matRowDef="let row; columns: displayedColumns" class="main-row"
        [ngClass]="{ expanded: trackIsExpanded(row) }" (click)="rowClicked1(row)"></mat-row> -->
    <!-- <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"
        [@detailExpand]="trackIsExpanded(row) ? 'expanded' : 'collapsed'"></mat-row> -->
</mat-table>
</div>

<mat-paginator [pageSizeOptions]="[25, 50, 100]" [disabled]="isBulkSaving" showFirstLastButtons aria-label="Select page of shows"></mat-paginator>

<div class="loading-overlay" *ngIf="isFetchingTableData">
    <app-loader color="#50e3c2"></app-loader>
</div>
